import { withTogglePointFactory } from "@asosteam/asos-web-toggle-point-app";
import sdkInstanceProvider from "../../client/sdkProvider";
import logWarning from "../../lib/logger";

const withTogglePoint = withTogglePointFactory({
  logWarning,
  sdkInstanceProvider
});

export default withTogglePoint;
